import { InviteeStatusEnum } from '../../models/jobInviteeStatusEnum';
import { JobStatusEnum } from '../../models/jobStatusEnum';
import { DispoUser } from '../../models/user';
import { getDispoArchivedJobsQuery } from './getDispoArchivedJobsQuery';

export type DispoArchivedTabJobsQueryOptions = {
  showCanceledWithArchived?: boolean;
  showOnlyCanceledJobs?: boolean;
  showOnlyBookedJobs?: boolean;
};

export function getDispoArchivedTabJobsQuery(
  user: DispoUser,
  {
    showCanceledWithArchived = false,
    showOnlyCanceledJobs = false,
    showOnlyBookedJobs = false,
  }: DispoArchivedTabJobsQueryOptions = {},
): object[] {
  const conditions: object[] = [];

  if (showOnlyCanceledJobs) {
    conditions.push({
      $or: [
        {
          status: JobStatusEnum.CANCELED,
        },
        {
          status: JobStatusEnum.ARCHIVED,
          invitees: {
            $elemMatch: {
              status: InviteeStatusEnum.CANCELED,
              'customer.id': user.customerId,
            },
          },
        },
      ],
    });
  } else if (showOnlyBookedJobs) {
    conditions.push({
      status: JobStatusEnum.ARCHIVED,
      $or: [
        {
          invitees: {
            $elemMatch: {
              status: InviteeStatusEnum.BOOKED,
              'customer.id': user.customerId,
            },
          },
        },
        {
          'invitees.status': InviteeStatusEnum.BOOKED,
          'customer.id': user.customerId,
        },
        {
          'invitees.status': InviteeStatusEnum.BOOKED,
          ownerCustomerIds: user.customerId,
        },
      ],
    });
  } else {
    conditions.push(
      getDispoArchivedJobsQuery(user, {
        includeCancelled: showCanceledWithArchived,
      }),
    );
  }

  return conditions;
}
